/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeedSignal } from '../models/FeedSignal';
import type { FeedSignalCreate } from '../models/FeedSignalCreate';
import type { FeedSignalPatch } from '../models/FeedSignalPatch';
import type { MatchSignal } from '../models/MatchSignal';
import type { MatchSignalCreate } from '../models/MatchSignalCreate';
import type { MatchSignalPatch } from '../models/MatchSignalPatch';
import type { StandingSignal } from '../models/StandingSignal';
import type { StandingSignalCreate } from '../models/StandingSignalCreate';
import type { StandingSignalPatch } from '../models/StandingSignalPatch';
import type { TeamSignal } from '../models/TeamSignal';
import type { TeamSignalCreate } from '../models/TeamSignalCreate';
import type { TeamSignalPatch } from '../models/TeamSignalPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SignalService {
    /**
     * Get Standing Signals
     * @param aoiId
     * @param userId
     * @param leagueId
     * @param resolved
     * @param offset
     * @param limit
     * @returns StandingSignal Successful Response
     * @throws ApiError
     */
    public static getStandingSignalsSignalStandingGet(
        aoiId?: (number | null),
        userId?: (number | null),
        leagueId?: (number | null),
        resolved?: (boolean | null),
        offset?: (number | null),
        limit?: (number | null),
    ): CancelablePromise<Array<StandingSignal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/signal/standing',
            query: {
                'aoi_id': aoiId,
                'user_id': userId,
                'league_id': leagueId,
                'resolved': resolved,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Standing Signal
     * @param requestBody
     * @returns StandingSignal Successful Response
     * @throws ApiError
     */
    public static createStandingSignalSignalStandingPost(
        requestBody: StandingSignalCreate,
    ): CancelablePromise<StandingSignal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signal/standing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match Signals
     * @param aoiId
     * @param userId
     * @param leagueId
     * @param resolved
     * @param offset
     * @param limit
     * @returns MatchSignal Successful Response
     * @throws ApiError
     */
    public static getMatchSignalsSignalMatchGet(
        aoiId?: (number | null),
        userId?: (number | null),
        leagueId?: (number | null),
        resolved?: (boolean | null),
        offset?: (number | null),
        limit?: (number | null),
    ): CancelablePromise<Array<MatchSignal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/signal/match',
            query: {
                'aoi_id': aoiId,
                'user_id': userId,
                'league_id': leagueId,
                'resolved': resolved,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Match Signal
     * @param requestBody
     * @returns MatchSignal Successful Response
     * @throws ApiError
     */
    public static createMatchSignalSignalMatchPost(
        requestBody: MatchSignalCreate,
    ): CancelablePromise<MatchSignal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signal/match',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Signals
     * @param aoiId
     * @param userId
     * @param leagueId
     * @param resolved
     * @param offset
     * @param limit
     * @returns TeamSignal Successful Response
     * @throws ApiError
     */
    public static getTeamSignalsSignalTeamGet(
        aoiId?: (number | null),
        userId?: (number | null),
        leagueId?: (number | null),
        resolved?: (boolean | null),
        offset?: (number | null),
        limit?: (number | null),
    ): CancelablePromise<Array<TeamSignal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/signal/team',
            query: {
                'aoi_id': aoiId,
                'user_id': userId,
                'league_id': leagueId,
                'resolved': resolved,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Team Signal
     * @param requestBody
     * @returns TeamSignal Successful Response
     * @throws ApiError
     */
    public static createTeamSignalSignalTeamPost(
        requestBody: TeamSignalCreate,
    ): CancelablePromise<TeamSignal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signal/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Feed Signals
     * @param aoiId
     * @param userId
     * @param matchId
     * @param postId
     * @param resolved
     * @param offset
     * @param limit
     * @returns FeedSignal Successful Response
     * @throws ApiError
     */
    public static getFeedSignalsSignalFeedGet(
        aoiId?: (number | null),
        userId?: (number | null),
        matchId?: (number | null),
        postId?: (number | null),
        resolved?: (boolean | null),
        offset?: (number | null),
        limit?: (number | null),
    ): CancelablePromise<Array<FeedSignal>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/signal/feed',
            query: {
                'aoi_id': aoiId,
                'user_id': userId,
                'match_id': matchId,
                'post_id': postId,
                'resolved': resolved,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Feed Signal
     * @param requestBody
     * @returns FeedSignal Successful Response
     * @throws ApiError
     */
    public static createFeedSignalSignalFeedPost(
        requestBody: FeedSignalCreate,
    ): CancelablePromise<FeedSignal> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/signal/feed',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Match Signal
     * @param matchSignalId
     * @param requestBody
     * @returns MatchSignal Successful Response
     * @throws ApiError
     */
    public static patchMatchSignalSignalMatchMatchSignalIdPatch(
        matchSignalId: number,
        requestBody: MatchSignalPatch,
    ): CancelablePromise<MatchSignal> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/signal/match/{match_signal_id}',
            path: {
                'match_signal_id': matchSignalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Team Signal
     * @param teamSignalId
     * @param requestBody
     * @returns TeamSignal Successful Response
     * @throws ApiError
     */
    public static patchTeamSignalSignalTeamTeamSignalIdPatch(
        teamSignalId: number,
        requestBody: TeamSignalPatch,
    ): CancelablePromise<TeamSignal> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/signal/team/{team_signal_id}',
            path: {
                'team_signal_id': teamSignalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Standing Signal
     * @param standingSignalId
     * @param requestBody
     * @returns StandingSignal Successful Response
     * @throws ApiError
     */
    public static patchStandingSignalSignalStandingStandgingSignalIdPatch(
        standingSignalId: number,
        requestBody: StandingSignalPatch,
    ): CancelablePromise<StandingSignal> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/signal/standing/{standging_signal_id}',
            query: {
                'standing_signal_id': standingSignalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Feed Signal
     * @param feedSignalId
     * @param requestBody
     * @returns FeedSignal Successful Response
     * @throws ApiError
     */
    public static patchFeedSignalSignalFeedFeedSignalIdPatch(
        feedSignalId: number,
        requestBody: FeedSignalPatch,
    ): CancelablePromise<FeedSignal> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/signal/feed/{feed_signal_id}',
            path: {
                'feed_signal_id': feedSignalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
